body[data-theme='light'] {
  /* colors */
  --colors-white: #ffffff;
  --colors-black: #000000;

  --colors-neutral-90: #202328;
  --colors-neutral-80: #32373e;
  --colors-neutral-70: #424952;
  --colors-neutral-60: #5f6771;
  --colors-neutral-50: #6f7780;
  --colors-neutral-40: #8e959e;
  --colors-neutral-30: #a1a8b0;
  --colors-neutral-20: #ced3da;
  --colors-neutral-10: #e7ebee;
  --colors-neutral-5: #f4f5f7;

  --colors-primary-90: #002152;
  --colors-primary-80: #002f75;
  --colors-primary-70: #0045ad;
  --colors-primary-60: #0254cf;
  --colors-primary-50: #146ef5;
  --colors-primary-40: #3f8bfd;
  --colors-primary-30: #6ba6ff;
  --colors-primary-20: #9ec5ff;
  --colors-primary-10: #dcebfe;
  --colors-primary-5: #ebf3ff;

  --colors-eggplant-90: #3f0250;
  --colors-eggplant-80: #57096d;
  --colors-eggplant-70: #7d2099;
  --colors-eggplant-60: #9d30bc;
  --colors-eggplant-50: #b245d1;
  --colors-eggplant-40: #c467de;
  --colors-eggplant-30: #d88eec;
  --colors-eggplant-20: #e5aff3;
  --colors-eggplant-10: #f8e3fd;
  --colors-eggplant-5: #fcf1fe;

  --colors-critical-90: #4d0505;
  --colors-critical-80: #6e0707;
  --colors-critical-70: #940a0a;
  --colors-critical-60: #bd0f0f;
  --colors-critical-50: #dd3131;
  --colors-critical-40: #ff584c;
  --colors-critical-30: #ff837a;
  --colors-critical-20: #ffb8b3;
  --colors-critical-10: #ffe3e0;
  --colors-critical-5: #fff1f0;

  --colors-success-90: #022c16;
  --colors-success-80: #033a1e;
  --colors-success-70: #044e28;
  --colors-success-60: #0c6734;
  --colors-success-50: #08873f;
  --colors-success-40: #0ba84f;
  --colors-success-30: #13c35f;
  --colors-success-20: #95e4aa;
  --colors-success-10: #c5f6da;
  --colors-success-5: #e5fbee;

  --colors-warning-80: #7a4900;
  --colors-warning-60: #c0873a;
  --colors-warning-50: #ffc700;
  --colors-warning-5: #fff1d6;

  --colors-status-criticalPressed: var(--colors-critical-60);
  --colors-status-criticalHover: var(--colors-critical-40);
  --colors-status-critical: var(--colors-critical-50);
  --colors-status-disabled: var(--colors-neutral-20);
  --colors-status-warning: var(--colors-warning-50);
  --colors-status-successPressed: var(--colors-success-60);
  --colors-status-successHover: var(--colors-critical-5);
  --colors-status-success: var(--colors-critical-50);

  /* shadows */
  --shadow-light: 0 4px 10px 0 rgba(32, 35, 40, 0.12);
  --shadow-heavy: 0 4px 10px 0 rgba(32, 35, 40, 0.25);
  --shadow-floating: 0 8px 20px 0 rgba(32, 35, 40, 0.2);

  /* radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-full: 999px;

  /* type settings */
  --font-family: 'DM Sans', sans-serif;
  --font-line-height: 1.375;
  --font-weight-regular: normal;
  --font-weight-semibold: 600;
  --font-weight-bold: 800;
}

body[data-theme='dark'] {
  /* colors */
  --colors-white: #ffffff;
  --colors-black: #000000;

  --colors-neutral-90: #202328;
  --colors-neutral-80: #32373e;
  --colors-neutral-70: #424952;
  --colors-neutral-60: #5f6771;
  --colors-neutral-50: #6f7780;
  --colors-neutral-40: #8e959e;
  --colors-neutral-30: #a1a8b0;
  --colors-neutral-20: #ced3da;
  --colors-neutral-10: #eceff3;
  --colors-neutral-5: #f4f5f7;

  --colors-primary-90: #002152;
  --colors-primary-80: #002f75;
  --colors-primary-70: #0045ad;
  --colors-primary-60: #0254cf;
  --colors-primary-50: #146ef5;
  --colors-primary-40: #3f8bfd;
  --colors-primary-30: #6ba6ff;
  --colors-primary-20: #9ec5ff;
  --colors-primary-10: #dcebfe;
  --colors-primary-5: #ebf3ff;

  --colors-eggplant-90: #3f0250;
  --colors-eggplant-80: #57096d;
  --colors-eggplant-70: #7d2099;
  --colors-eggplant-60: #9d30bc;
  --colors-eggplant-50: #b245d1;
  --colors-eggplant-40: #c467de;
  --colors-eggplant-30: #d88eec;
  --colors-eggplant-20: #e5aff3;
  --colors-eggplant-10: #f8e3fd;
  --colors-eggplant-5: #fcf1fe;

  --colors-critical-90: #4d0505;
  --colors-critical-80: #6e0707;
  --colors-critical-70: #940a0a;
  --colors-critical-60: #bd0f0f;
  --colors-critical-50: #dd3131;
  --colors-critical-40: #ff584c;
  --colors-critical-30: #ff837a;
  --colors-critical-20: #ffb8b3;
  --colors-critical-10: #fff1f0;
  --colors-critical-5: #fcf1fe;

  --colors-success-90: #022c16;
  --colors-success-80: #033a1e;
  --colors-success-70: #044e28;
  --colors-success-60: #0c6734;
  --colors-success-50: #08873f;
  --colors-success-40: #0ba84f;
  --colors-success-30: #13c35f;
  --colors-success-20: #95e4aa;
  --colors-success-10: #c5f6da;
  --colors-success-5: #e5fbee;

  --colors-warning-80: #7a4900;
  --colors-warning-60: #c0873a;
  --colors-warning-50: #ffc700;
  --colors-warning-5: #fff1d6;

  --colors-status-criticalPressed: var(--colors-critical-60);
  --colors-status-criticalHover: var(--colors-critical-40);
  --colors-status-critical: var(--colors-critical-50);
  --colors-status-disabled: var(--colors-neutral-20);
  --colors-status-warning: var(--colors-warning-50);
  --colors-status-successPressed: var(--colors-success-60);
  --colors-status-successHover: var(--colors-critical-5);
  --colors-status-success: var(--colors-critical-50);

  /* shadows */
  --shadow-light: 0 4px 10px 0 rgba(32, 35, 40, 0.12);
  --shadow-heavy: 0 4px 10px 0 rgba(32, 35, 40, 0.25);
  --shadow-floating: 0 8px 20px 0 rgba(32, 35, 40, 0.2);

  /* radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-full: 999px;

  /* type settings */
  --font-family: 'DM Sans', sans-serif;
  --font-line-height: 1.375;
  --font-weight-regular: normal;
  --font-weight-semibold: 600;
  --font-weight-bold: 800;
}

@media print {
  .hideforprint {
    display: none !important;
  }
}
